<template lang="pug">
  .favorites
    cvs(v-if="[CONSTANTS.EMPLOYER_PROFILE_TYPE, CONSTANTS.RECEIVER_PROFILE_TYPE].indexOf(getUser.profile_type) !== -1")
    jobs(v-else)
</template>

<script>
import cvs from './cvs'
import jobs from './jobs'
import {mapGetters} from 'vuex'

const CONSTANTS = require('@/constants.json')

export default {
  name: 'Favorites',
  data () {
    return {
      CONSTANTS: CONSTANTS
    }
  },
  components: {
    cvs,
    jobs
  },
  computed: {
    ...mapGetters(['getUser'])
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/favorites/index.vue